import { createRouter, createWebHistory } from 'vue-router'
import { useSettingsStore } from '../stores/settingsStore'

import Home from '../pages/Home.vue'
import Products from '../pages/Products.vue'
import ProductDetail from '../pages/ProductDetail.vue'
import Services from '../pages/Services.vue'
import Projects from '../pages/Projects.vue'
import ProjectDetail from '../pages/ProjectDetail.vue'
import InstallationGuide from '../pages/InstallationGuide.vue'
import PaymentGuide from '../pages/PaymentGuide.vue'
import About from '../pages/About.vue'
import VerifyEmail from '../pages/VerifyEmail.vue'
import LineCallback from '../pages/LineCallback.vue'
import ForgotPassword from '../pages/ForgotPassword.vue'
import ResetPassword from '../pages/ResetPassword.vue'
import Quotation from '../pages/Quotation.vue'
import Contact from '../pages/Contact.vue'
import Profile from '../pages/Profile.vue'
import Cart from '../pages/Cart.vue'
import Checkout from '../pages/Checkout.vue'
import OrderSuccess from '../pages/OrderSuccess.vue'
import RecentlyViewedPage from '../pages/RecentlyViewedPage.vue'
import Compare from '../pages/Compare.vue'
import SpaceCalculator from '../pages/SpaceCalculator.vue'
import FAQ from '../pages/FAQ.vue'
import PrivacyPolicy from '../pages/PrivacyPolicy.vue'
import TermsOfService from '../pages/TermsOfService.vue'
import CookiePolicy from '../pages/CookiePolicy.vue'
import WarrantyPolicy from '../pages/WarrantyPolicy.vue'
import Blog from '../pages/Blog.vue'
import BlogDetail from '../pages/BlogDetail.vue'
import Maintenance from '../pages/Maintenance.vue'
import ServerError from '../pages/ServerError.vue'
import NotFound from '../pages/NotFound.vue'

// Lazy-load Admin Routes for Optimal Initial Load Performance
const AdminLogin = () => import('../pages/admin/Login.vue')
const PrintDocument = () => import('../pages/admin/PrintDocument.vue')
const AdminLayout = () => import('../pages/admin/AdminLayout.vue')
const Dashboard = () => import('../pages/admin/Dashboard.vue')
const AnalyticsAdmin = () => import('../pages/admin/AnalyticsAdmin.vue')
const HomeAdmin = () => import('../pages/admin/HomeAdmin.vue')
const ProductsAdmin = () => import('../pages/admin/ProductsAdmin.vue')
const ProductFormAdmin = () => import('../pages/admin/ProductFormAdmin.vue')
const CategoriesAdmin = () => import('../pages/admin/CategoriesAdmin.vue')
const CategoryFormAdmin = () => import('../pages/admin/CategoryFormAdmin.vue')
const LeadsAdmin = () => import('../pages/admin/LeadsAdmin.vue')
const OrdersAdmin = () => import('../pages/admin/OrdersAdmin.vue')
const OrderDetailAdmin = () => import('../pages/admin/OrderDetailAdmin.vue')
const InboxAdmin = () => import('../pages/admin/InboxAdmin.vue')
const NewsletterAdmin = () => import('../pages/admin/NewsletterAdmin.vue')
const ContactAdmin = () => import('../pages/admin/ContactAdmin.vue')
const FooterAdmin = () => import('../pages/admin/FooterAdmin.vue')
const FAQAdmin = () => import('../pages/admin/FAQAdmin.vue')
const AboutAdmin = () => import('../pages/admin/AboutAdmin.vue')
const ServicesAdmin = () => import('../pages/admin/ServicesAdmin.vue')
const ProjectsAdmin = () => import('../pages/admin/ProjectsAdmin.vue')
const ArticlesAdmin = () => import('../pages/admin/ArticlesAdmin.vue')
const CustomersAdmin = () => import('../pages/admin/CustomersAdmin.vue')
const CustomerDetailAdmin = () => import('../pages/admin/CustomerDetailAdmin.vue')
const AdminUsersAdmin = () => import('../pages/admin/AdminUsersAdmin.vue')
const ProfileAdmin = () => import('../pages/admin/ProfileAdmin.vue')
const SettingsAdmin = () => import('../pages/admin/SettingsAdmin.vue')
const LogsAdmin = () => import('../pages/admin/LogsAdmin.vue')
const PoliciesAdmin = () => import('../pages/admin/PoliciesAdmin.vue')
const GuidesAdmin = () => import('../pages/admin/GuidesAdmin.vue')
const Manual = () => import('../pages/admin/Manual.vue')
const ReviewsAdmin = () => import('../pages/admin/ReviewsAdmin.vue')
const CouponsAdmin = () => import('../pages/admin/CouponsAdmin.vue')
const LineAdmin = () => import('../pages/admin/LineAdmin.vue')

const routes = [
    {
        path: '/',
        component: Home,
        meta: { title: 'Morespace - บ้านเก็บของและโรงเรือนสำเร็จรูประดับพรีเมียม', description: 'Morespace โดยบริษัท ซีอาร์ ดิสทริบิวชั่น จำกัด จำหน่ายและติดตั้งบ้านเก็บของ โรงเรือน และโกดังสำเร็จรูปคุณภาพสูง รับประกัน 10 ปี' }
    },
    {
        path: '/products',
        component: Products,
        meta: { title: 'แคตตาล็อกสินค้า - Morespace บ้านเก็บของพรีเมียม', description: 'เลือกชมแคตตาล็อกสินค้ามากกว่า 100 รายการ ทั้งบ้านเก็บของ PP/HDPE, โรงจอดรถ และโรงเรือนเพาะปลูก' }
    },
    {
        path: '/products/category/:category',
        component: Products,
        meta: { title: 'สินค้าหมวดหมู่ - Morespace', description: 'สินค้าในหมวดหมู่ที่เลือก - Morespace บ้านเก็บของและโรงเรือนพรีเมียม' }
    },
    {
        path: '/products/:slug',
        component: ProductDetail,
        meta: { title: 'รายละเอียดสินค้า - Morespace', description: 'ข้อมูลรายละเอียด สเปค และราคาของสินค้า โครงสร้างเหล็กแข็งแรงทนทาน' }
    },
    {
        path: '/services',
        component: Services,
        meta: { title: 'บริการของเรา - Morespace ผู้เชี่ยวชาญด้านงานติดตั้ง', description: 'บริการให้คำปรึกษา ประเมินหน้างาน และติดตั้งบ้านเก็บของอย่างมืออาชีพโดยวิศวกรและช่างผู้ชำนาญการ' }
    },
    {
        path: '/projects',
        component: Projects,
        meta: { title: 'แฟ้มผลงาน - Morespace', description: 'ชมผลงานการติดตั้งจริงของ Morespace ทั่วประเทศ สร้างความมั่นใจด้วยมาตรฐานระดับสากล' }
    },
    {
        path: '/projects/:slug',
        component: ProjectDetail,
        meta: { title: 'รายละเอียดผลงาน - Morespace' }
    },
    {
        path: '/installation-guide',
        component: InstallationGuide,
        meta: { title: 'คู่มือการเตรียมพื้นที่และติดตั้ง - Morespace', description: 'คลิปวิดีโอคู่มือและข้อมูลการเตรียมพื้นที่หน้างานก่อนการติดตั้งบ้านเก็บของหรือโรงเรือน' }
    },
    {
        path: '/payment-methods',
        component: PaymentGuide,
        meta: { title: 'วิธีการสั่งซื้อและชำระเงิน - Morespace', description: 'ขั้นตอนการสั่งซื้อสินค้า ช่องทางการชำระเงิน และนโยบายทางการเงิน' }
    },
    {
        path: '/about',
        component: About,
        meta: { title: 'เกี่ยวกับเรา - บริษัท ซีอาร์ ดิสทริบิวชั่น จำกัด', description: 'ทำความรู้จักกับบริษัท ซีอาร์ ดิสทริบิวชั่น ผู้เชี่ยวชาญด้านสินค้านำเข้าอุตสาหกรรมด้วยประสบการณ์กว่า 20 ปี' }
    },
    {
        path: '/verify-email',
        component: VerifyEmail,
        meta: { title: 'ยืนยันอีเมลของคุณ - Morespace', description: 'ยืนยันตัวตนเพื่อเข้าถึงสิทธิประโยชน์จาก Morespace แบบเต็มรูปแบบ' }
    },
    {
        path: '/auth/line/callback',
        component: LineCallback,
        meta: { title: 'กำลังเข้าสู่ระบบ - Morespace' }
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
        meta: { title: 'ลืมรหัสผ่าน - Morespace', description: 'ขอลิงก์รีเซ็ตรหัสผ่านผ่านอีเมล' }
    },
    {
        path: '/reset-password',
        component: ResetPassword,
        meta: { title: 'ตั้งรหัสผ่านใหม่ - Morespace', description: 'ตั้งรหัสผ่านใหม่สำหรับบัญชีของคุณ' }
    },
    {
        path: '/quotation',
        component: Quotation,
        meta: { title: 'ขอใบเสนอราคา - Morespace', description: 'กรอกแบบฟอร์มเพื่อขอรับใบเสนอราคาบ้านเก็บของ หรือนัดหมายช่างประเมินหน้างาน' }
    },
    {
        path: '/contact',
        component: Contact,
        meta: { title: 'ติดต่อเรา - Morespace', description: 'ช่องทางการติดต่อ Morespace ที่อยู่สำนักงาน อีเมล เบอร์โทรศัพท์ และ Line Official' }
    },
    {
        path: '/profile',
        component: Profile,
        meta: { title: 'บัญชีของฉัน - Morespace' }
    },
    {
        path: '/cart',
        component: Cart,
        meta: { title: 'ตะกร้าสินค้า - Morespace', description: 'ตรวจสอบรายการสินค้าและดำเนินการสั่งซื้อ Morespace' }
    },
    {
        path: '/checkout',
        component: Checkout,
        meta: { title: 'ชำระเงิน - Morespace', description: 'ดำเนินการชำระเงินและกรอกข้อมูลจัดส่ง' }
    },
    {
        path: '/order-success/:id',
        component: OrderSuccess,
        meta: { title: 'สั่งซื้อสำเร็จ - Morespace' }
    },
    {
        path: '/recently-viewed',
        component: RecentlyViewedPage,
        meta: { title: 'ประวัติการดูสินค้า - Morespace', description: 'ประวัติสินค้าที่คุณเคยดู' }
    },
    {
        path: '/compare',
        component: Compare,
        meta: { title: 'เปรียบเทียบสินค้า - Morespace', description: 'เปรียบเทียบคุณสมบัติและราคาของสินค้าแบบ side-by-side' }
    },
    {
        path: '/space-calculator',
        component: SpaceCalculator,
        meta: { title: 'ประเมินพื้นที่และราคา - Morespace', description: 'เครื่องมือคำนวณขนาดพื้นที่ แนะนำสินค้าที่เหมาะสมพร้อมประเมินราคา' }
    },
    {
        path: '/faq',
        component: FAQ,
        meta: { title: 'คำถามที่พบบ่อย (FAQ) - Morespace', description: 'คำถามที่พบบ่อยเกี่ยวกับการเลือกซื้อ การจัดส่ง การติดตั้ง และการรับประกันสินค้า Morespace' }
    },

    // Legal & Utilities
    {
        path: '/privacy-policy',
        component: PrivacyPolicy,
        meta: { title: 'นโยบายความเป็นส่วนตัว - Morespace', description: 'รายละเอียดนโยบายความเป็นส่วนตัวและการคุ้มครองข้อมูลส่วนบุคคล (PDPA) ของบริษัท ซีอาร์ ดิสทริบิวชั่น จำกัด' }
    },
    {
        path: '/terms',
        component: TermsOfService,
        meta: { title: 'เงื่อนไขการให้บริการ - Morespace', description: 'ข้อกำหนดและเงื่อนไขการใช้งานแพลตฟอร์ม Morespace รวมถึงนโยบายการรับประกันสินค้า' }
    },
    {
        path: '/cookie-policy',
        component: CookiePolicy,
        meta: { title: 'นโยบายการใช้คุกกี้ - Morespace', description: 'รายละเอียดนโยบายการใช้คุกกี้ (Cookie Policy) ของเว็บไซต์ Morespace' }
    },
    {
        path: '/warranty',
        component: WarrantyPolicy,
        meta: { title: 'นโยบายการรับประกัน - Morespace', description: 'เงื่อนไขการรับประกันและข้อยกเว้นสำหรับสินค้าและบริการก่อสร้างโกดังของ Morespace' }
    },
    {
        path: '/blog',
        component: Blog,
        meta: { title: 'บทความและความรู้ - Morespace', description: 'บทความให้ความรู้เกี่ยวกับบ้านเก็บของ โรงเรือน การดูแลรักษา และเคล็ดลับจัดพื้นที่' }
    },
    {
        path: '/blog/:slug',
        component: BlogDetail,
        meta: { title: 'บทความ - Morespace' }
    },
    {
        path: '/maintenance',
        component: Maintenance,
        meta: { title: 'ปิดปรับปรุงระบบชั่วคราว - Morespace', isMaintenancePage: true }
    },
    {
        path: '/error',
        component: ServerError,
        meta: { title: 'เกิดข้อผิดพลาด - Morespace' }
    },
    {
        path: '/:pathMatch(.*)*',
        component: NotFound,
        meta: { title: '404 ไม่พบหน้าเว็บ - Morespace' }
    },
    {
        path: '/admin/login',
        component: AdminLogin,
        meta: { title: 'เข้าสู่ระบบ - Morespace Admin' }
    },
    {
        path: '/admin/orders/:id/print/:docType',
        component: PrintDocument,
        meta: { title: 'พิมพ์เอกสาร - Admin' }
    },
    {
        path: '/admin',
        component: AdminLayout,
        meta: { title: 'ระบบจัดการส่วนหลังบ้าน - Morespace' },
        children: [
            { path: '', component: Dashboard, meta: { title: 'Dashboard - Admin' } },
            { path: 'analytics', component: AnalyticsAdmin, meta: { title: 'Analytics - Admin' } },
            { path: 'homepage', component: HomeAdmin, meta: { title: 'จัดการหน้าหลัก - Admin' } },
            { path: 'products', component: ProductsAdmin, meta: { title: 'จัดการสินค้า - Admin' } },
            { path: 'products/new', component: ProductFormAdmin, meta: { title: 'เพิ่มสินค้า - Admin' } },
            { path: 'products/:id/edit', component: ProductFormAdmin, meta: { title: 'แก้ไขสินค้า - Admin' } },
            { path: 'categories', component: CategoriesAdmin, meta: { title: 'จัดการหมวดหมู่ - Admin' } },
            { path: 'categories/new', component: CategoryFormAdmin, meta: { title: 'เพิ่มหมวดหมู่ - Admin' } },
            { path: 'categories/:id/edit', component: CategoryFormAdmin, meta: { title: 'แก้ไขหมวดหมู่ - Admin' } },
            { path: 'leads', component: LeadsAdmin, meta: { title: 'ระบบหลังบ้าน Leads - Admin' } },
            { path: 'orders', component: OrdersAdmin, meta: { title: 'จัดการคำสั่งซื้อ - Admin' } },
            { path: 'orders/:id', component: OrderDetailAdmin, meta: { title: 'รายละเอียดคำสั่งซื้อ - Admin' } },
            { path: 'inbox', component: InboxAdmin, meta: { title: 'กล่องข้อความ - Admin' } },
            { path: 'newsletter', component: NewsletterAdmin, meta: { title: 'สมาชิกข่าวสาร - Admin' } },
            { path: 'contact', component: ContactAdmin, meta: { title: 'จัดการข้อมูลติดต่อ - Admin' } },
            { path: 'footer', component: FooterAdmin, meta: { title: 'จัดการ Footer - Admin' } },
            { path: 'faq', component: FAQAdmin, meta: { title: 'จัดการคำถามที่พบบ่อย - Admin' } },
            { path: 'about', component: AboutAdmin, meta: { title: 'จัดการเนื้อหา เกี่ยวกับเรา - Admin' } },
            { path: 'services', component: ServicesAdmin, meta: { title: 'จัดการหน้าบริการ - Admin' } },
            { path: 'projects', component: ProjectsAdmin, meta: { title: 'จัดการหน้าผลงาน - Admin' } },
            { path: 'articles', component: ArticlesAdmin, meta: { title: 'จัดการบทความ - Admin' } },
            { path: 'customers', component: CustomersAdmin, meta: { title: 'จัดการลูกค้าสมาชิก - Admin' } },
            { path: 'customers/:id', component: CustomerDetailAdmin, meta: { title: 'รายละเอียดลูกค้า - Admin' } },
            { path: 'users', component: AdminUsersAdmin, meta: { title: 'จัดการผู้ดูแลระบบ - Admin' } },
            { path: 'profile', component: ProfileAdmin, meta: { title: 'โปรไฟล์ผู้ดูแลระบบ - Admin' } },
            { path: 'settings', component: SettingsAdmin, meta: { title: 'ตั้งค่าระบบ - Admin' } },
            { path: 'logs', component: LogsAdmin, meta: { title: 'บันทึกระบบ (System Logs) - Admin' } },
            { path: 'logs/orders', component: LogsAdmin, meta: { title: 'ประวัติกิจกรรมคำสั่งซื้อ - Admin' } },
            { path: 'logs/emails', component: LogsAdmin, meta: { title: 'ประวัติส่งอีเมล (Email Logs) - Admin' } },
            { path: 'policies', component: PoliciesAdmin, meta: { title: 'จัดการนโยบายและข้อตกลง - Admin' } },
            { path: 'guides', component: GuidesAdmin, meta: { title: 'จัดการคู่มือและวิธีการต่างๆ - Admin' } },
            { path: 'manual', component: Manual, meta: { title: 'คู่มือการใช้งานแบบละเอียด - Admin' } },
            { path: 'reviews', component: ReviewsAdmin, meta: { title: 'จัดการรีวิวสินค้า - Admin' } },
            { path: 'coupons', component: CouponsAdmin, meta: { title: 'จัดการโค้ดส่วนลด - Admin' } },
            { path: 'line', component: LineAdmin, meta: { title: 'จัดการ Line Official - Admin' } }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        return { top: 0, behavior: 'smooth' }
    }
})

// Navigation Guard for SEO Meta Tags
router.beforeEach((to, from, next) => {
    // Set Title
    document.title = to.meta.title || 'Morespace - ระบบจัดการบ้านเก็บของอัจฉริยะ'

    // Set Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]')
    if (!canonical) {
        canonical = document.createElement('link')
        canonical.setAttribute('rel', 'canonical')
        document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', `https://morespace.co.th${to.path === '/' ? '' : to.path}`)


    // Set Meta Description
    const description = to.meta.description || 'เว็บไซต์จำหน่ายและให้คำปรึกษาการสร้างบ้านเก็บของและโรงเรือน'
    const metaDescriptionTag = document.querySelector('meta[name="description"]')
    if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute('content', description)
    } else if (to.meta.description) {
        const meta = document.createElement('meta')
        meta.name = 'description'
        meta.content = description
        document.head.appendChild(meta)
    }

    // Dynamic OG Meta Tags for social sharing
    const ogTags = {
        'og:title': document.title,
        'og:description': description,
        'og:url': `https://morespace.co.th${to.fullPath}`,
        'twitter:title': document.title,
        'twitter:description': description,
    }
    for (const [property, content] of Object.entries(ogTags)) {
        const isOg = property.startsWith('og:')
        const selector = isOg ? `meta[property="${property}"]` : `meta[name="${property}"]`
        let tag = document.querySelector(selector)
        if (tag) {
            tag.setAttribute('content', content)
        } else {
            tag = document.createElement('meta')
            if (isOg) tag.setAttribute('property', property)
            else tag.name = property
            tag.content = content
            document.head.appendChild(tag)
        }
    }

    // Admin Authentication Guard
    if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
        const token = localStorage.getItem('adminToken')
        if (!token) {
            return next('/admin/login')
        }
    }

    // Maintenance Mode Guard (exclude admin routes and the maintenance page itself)
    try {
        const settingsStore = useSettingsStore()
        if (settingsStore.maintenanceModeEnabled && !to.path.startsWith('/admin') && !to.meta.isMaintenancePage) {
            return next('/maintenance')
        }
        // If maintenance is OFF but user is on maintenance page, redirect to home
        if (!settingsStore.maintenanceModeEnabled && to.meta.isMaintenancePage) {
            return next('/')
        }
    } catch (e) {}

    // Online Shopping Guard
    try {
        const settingsStore = useSettingsStore()
        if (!settingsStore.isOnlineShoppingEnabled && (to.path === '/cart' || to.path === '/profile' || to.path === '/verify-email')) {
            return next('/')
        }
    } catch (e) {
        // Pinia might not be fully initialized on the very first route resolution
    }

    next()
})

export default router
